import { observer } from 'mobx-react-lite'
import { useEffect, useState } from 'react'
import { Alert, Button } from 'antd'
import i from '../../translations/i'
import { openApi } from '../../helpers/request'
import { storeSession } from '../../helpers/stores'
import { days, formatDate, isAdminRole } from '../../front/billing/billing.helpers'

/** Закрытое предупреждение не показываем до конца сессии — но только для этого статуса */
const DISMISS_KEY = 'billing_banner_dismissed'

/**
 * Предупреждение об окончании подписки над содержимым любой страницы админки.
 * Видят только администраторы: остальные роли оплатить тариф всё равно не могут.
 */
export const BillingBanner = observer(() => {
    const [status, setStatus] = useState<any>(null)
    const [dismissed, setDismissed] = useState<string | null>(storeSession.get(DISMISS_KEY) ?? null)

    const onBillingPage = window.location.pathname.startsWith('/billing')

    useEffect(() => {
        if (!isAdminRole() || window.location.pathname.startsWith('/billing')) return

        openApi('get', '/billing/status', {}, undefined, true)
            .then(result => setStatus(result.data))
            .catch(() => setStatus(null))
    }, [])

    const subscription = status?.subscription

    if (!status?.available || !subscription || onBillingPage) return null
    if (subscription.status !== 'expiring' && subscription.status !== 'expired') return null

    const key = `${subscription.status}:${subscription.paid_until}`
    if (dismissed === key) return null

    const dismiss = () => {
        storeSession.set(DISMISS_KEY, key)
        setDismissed(key)
    }

    const expired = subscription.status === 'expired'

    return (
        <Alert
            className="billing-banner"
            type={expired ? 'error' : 'warning'}
            showIcon
            closable
            onClose={dismiss}
            style={{ marginBottom: 16, borderRadius: 12 }}
            message={expired
                ? i.t('billing:banner.expired', { date: formatDate(subscription.paid_until) })
                : i.t('billing:banner.expiring', { left: days(subscription.days_left), date: formatDate(subscription.paid_until) })
            }
            action={<Button size="small" type="primary" href="/billing">{i.t('billing:banner.action')}</Button>}
        />
    )
})
